import { Record, List } from 'immutable';

const OnlineusageRecord = Record({
  studentId: undefined,
  spinProcess: undefined,
  unitOnlineUsages: undefined,
  selectedCourse: new List(),
});

class OnlineUsage extends OnlineusageRecord { }

export default OnlineUsage;



// WEBPACK FOOTER //
// ./data/OnlineUsage/model.js